const routes = [
  {
    path: '/modulo',
    name: 'Módulos',
    component: () => import('@/views/forms/Modulo.vue')
  },
  {
    path: '/parametro',
    name: 'Parámetros',
    component: () => import('@/views/forms/Parametro.vue')
  },
  {
    path: '/perfil',
    name: 'Perfiles de Usuario',
    component: () => import('@/views/forms/Perfil.vue')
  },
  {
    path: '/rol',
    name: 'Roles de Usuarios',
    component: () => import('@/views/forms/Rol.vue')
  },
  {
    path: '/plan',
    name: 'Planes',
    component: () => import('@/views/forms/Plan.vue')
  },
  {
    path: '/moduplan',
    name: 'Módulos por Plan',
    component: () => import('@/views/forms/ModuPlan.vue')
  },
  {
    path: '/moduusua',
    name: 'Módulos por Usuarios',
    component: () => import('@/views/forms/ModuUsua.vue')
  },
  {
    path: '/formapago',
    name: 'Forma de Pago',
    component: () => import('@/views/forms/FormaPago.vue')
  },
  {
    path: '/suscripcion',
    name: 'Suscripción',
    component: () => import('@/views/forms/Suscripcion.vue')
  },
  {
    path: '/tablmodu',
    name: 'Tablas por Módulo',
    component: () => import('@/views/forms/TablModu.vue')
  },
  {
    path: '/rolmodu',
    name: 'Roles por Módulo',
    component: () => import('@/views/forms/RolModu.vue')
  },
  {
    path: '/suscpago',
    name: 'Pagos por Suscripción',
    component: () => import('@/views/forms/SuscPago.vue')
  },
  {
    path: '/tipoiden',
    name: 'Tipos de Identificación',
    component: () => import('@/views/forms/TipoIden.vue')
  },
  {
    path: '/estadocivil',
    name: 'Estado Civil',
    component: () => import('@/views/forms/EstadoCivil.vue')
  },
  {
    path: '/localidad',
    name: 'Localidades',
    component: () => import('@/views/forms/Localidad.vue')
  },
  {
    path: '/mediocom',
    name: 'Medios de Comunicación',
    component: () => import('@/views/forms/MedioCom.vue')
  },
  {
    path: '/asegurador',
    name: 'Asegurador',
    component: () => import('@/views/forms/Asegurador.vue')
  },
  {
    path: '/impuesto',
    name: 'Impuestos',
    component: () => import('@/views/forms/Impuesto.vue')
  },
  {
    path: '/tipoelem',
    name: 'Tipos de Elementos',
    component: () => import('@/views/forms/TipoElem.vue')
  },
  {
    path: '/claselem',
    name: 'Clasificación de Elementos',
    component: () => import('@/views/forms/ClasElem.vue')
  },
  {
    path: '/elemento',
    name: 'Elemento',
    component: () => import('@/views/forms/Elemento.vue')
  },
  {
    path: '/clasdiag',
    name: 'Clasificación de Diagnósticos',
    component: () => import('@/views/forms/ClasDiag.vue')
  },
  {
    path: '/diagnostico',
    name: 'Diagnósticos',
    component: () => import('@/views/forms/Diagnostico.vue')
  },
  {
    path: '/tipoexamen',
    name: 'Tipo de Examen',
    component: () => import('@/views/forms/TipoExamen.vue')
  },
  {
    path: '/anatomia',
    name: 'Anatomía',
    component: () => import('@/views/forms/Anatomia.vue')
  },
  {
    path: '/antecedente',
    name: 'Antecedente',
    component: () => import('@/views/forms/Antecedente.vue')
  },
  {
    path: '/biometria',
    name: 'Biometría',
    component: () => import('@/views/forms/Biometria.vue')
  },
  {
    path: '/dosis',
    name: 'Dosis',
    component: () => import('@/views/forms/Biometria.vue')
  },
  {
    path: '/examenfisico',
    name: 'Examen Físico',
    component: () => import('@/views/forms/ExamenFisico.vue')
  },
  {
    path: '/especialidad',
    name: 'Especialidad',
    component: () => import('@/views/forms/Especialidad.vue')
  },
  {
    path: '/frecuencia',
    name: 'Frecuencia',
    component: () => import('@/views/forms/Frecuencia.vue')
  },
  {
    path: '/motivoref',
    name: 'Motivo Referencia',
    component: () => import('@/views/forms/MotivoRef.vue')
  },
  {
    path: '/empresaimg',
    name: 'Empresa Imagen',
    component: () => import('@/views/forms/EmpresaImg.vue')
  },
  {
    path: '/fechacita',
    name: 'Fecha Cita',
    component: () => import('@/views/forms/FechaCita.vue')
  },
  {
    path: '/grupoetareo',
    name: 'Grupo Etareo',
    component: () => import('@/views/forms/GrupoEtareo.vue')
  },
  {
    path: '/horario',
    name: 'Horarios',
    component: () => import('@/views/forms/Horario.vue')
  },
  {
    path: '/mediocomimg',
    name: 'Medio Com Imagen',
    component: () => import('@/views/forms/MedioComImg.vue')
  },
  {
    path: '/medioemp',
    name: 'Empresa Medios de Comunicación',
    component: () => import('@/views/forms/MedioEmp.vue')
  },
  {
    path: '/mediopers',
    name: 'Persona Medios de Comunicación',
    component: () => import('@/views/forms/MedioPers.vue')
  },
  {
    path: '/paremp',
    name: 'Parámetros por Empresa',
    component: () => import('@/views/forms/ParEmp.vue')
  }
];

export { routes };
